<template>
  <router-link tag="a" :to="{ name: 'screens.single', params: { screenId: screen.id } }">
    <div class="row">
      <div class="col-12 col-xl-3">
        <div class="row">
          <div class="col d-flex align-items-center">
            <p class="text-truncate text-wrap">{{ screen.name }}</p>
          </div>
        </div><!-- /.row -->
      </div>
      <div class="col-12 col-xl-3 flex-grow-1">
        <div class="d-flex flex-wrap align-items-center gap-2">
          <template v-if="screen.tags.length">
            <div v-for="tag in screen.tags" :key="`screen-tag-${tag.id}`" class="chip chip-primary">
              {{ tag.name }}
            </div>
          </template>
          <template v-if="screen.media_owner_screen_tags && screen.media_owner_screen_tags.length">
            <div v-for="tag in screen.media_owner_screen_tags" :key="`mo-screen-tag-${tag.id}`" class="chip chip-primary">
              {{ tag.name }}
            </div>
          </template>
          <span v-if="!screen.tags.length && !(screen.media_owner_screen_tags && screen.media_owner_screen_tags.length)" class="text-muted">-</span>
        </div>
      </div>
      <div class="col-12 col-md-4 col-xl-2">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Media Owner{{ mediaOwnerNames.length > 1 ? 's' : '' }}</span>
          {{ mediaOwnerNames.length > 0 ? mediaOwnerNames.join(', ') : '-' }}
        </p>
      </div>
      <div class="col-6 col-md-4 col-xl-2">
        <p>
          <span class="data-label d-xl-none">Current Brightness</span>
          <template v-if="!screen.is_manual">{{ screen.brightness }} {{ screen.brightness_percentage === '-' ? '' : '('+screen.brightness_percentage+'%)' }}</template>
          <template v-else>-</template>
        </p>
      </div>
      <div class="col-6 col-md-4 col-xl-2">
        <p>
          <span class="data-label d-xl-none">Ambient Brightness</span>
          <template v-if="!screen.is_manual">{{ screen.environment_brightness }}</template>
          <template v-else>-</template>
        </p>
      </div>
    </div>
    <i
        v-if="!screen.is_manual"
        data-bs-toggle="tooltip"
        class="indicator far fa-fw"
        :class="indicatorClass()"
        :data-bs-original-title="screen.status"
        :aria-label="screen.status"
    ></i>
  </router-link>
</template>

<script>
export default {
  props: {
    screen: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      indicatorClasses: {
        'No Issues': 'fa-check text-success',
        'Communication Error': 'fa-wifi-slash text-warning',
        Offline: 'fa-wifi-slash text-warning',
        Fault: 'fa-exclamation-triangle text-danger'
      }
    }
  },

  computed: {
    mediaOwnerNames () {
      if (this.screen.media_owners && this.screen.media_owners.length > 0) {
        return this.screen.media_owners.map(mo => mo.name)
      }
      return []
    }
  },

  methods: {
    indicatorClass () {
      return this.indicatorClasses[this.screen.status]
    },
  }
}
</script>
